import { HTTP } from '../../http-common'

export default {
  state: {
    loadedInnerCurtains: []
  },
  getters: {
    loadedInnerCurtains (state) {
      return state.loadedInnerCurtains
    }
  },
  mutations: {
    setLoadedInnerCurtains (state, payload) {
      state.loadedInnerCurtains = payload
    },
    createInnerCurtain (state, payload) {
      state.loadedInnerCurtains.push(payload)
    },
    updateInnerCurtain (state, payload) {
      state.loadedInnerCurtains = state.loadedInnerCurtains.map(innerCurtain => innerCurtain.id === payload.id ? payload : innerCurtain)
    },
    removeInnerCurtain (state, id) {
      state.loadedInnerCurtains = state.loadedInnerCurtains.filter(innerCurtain => {
        return innerCurtain.id !== id
      })
    },
    clearLoadedInnerCurtains (state) {
      state.loadedInnerCurtains = []
    }
  },
  actions: {
    loadInnerCurtains ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedInnerCurtains', [])

      return new Promise((resolve, reject) => {
        HTTP.get('inner_curtain_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedInnerCurtains', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createInnerCurtain ({ commit, getters }, payload) {
      console.log('createInnerCurtain')
      commit('clearError')
      commit('setLoading', true)
      const newInnerCurtain = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('inner_curtain_type.json/', newInnerCurtain)
          .then(result => {
            console.log(result)
            commit('createInnerCurtain', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateInnerCurtain ({ commit, getters }, payload) {
      console.log('updateInnerCurtain')
      commit('clearError')
      commit('setLoading', true)
      const innerCurtain = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`inner_curtain_type.json/${payload.id}/`, innerCurtain)
          .then(result => {
            console.log(result)
            commit('updateInnerCurtain', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeInnerCurtain ({ commit }, payload) {
      console.log('removeInnerCurtain')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`inner_curtain_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeInnerCurtain', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedInnerCurtains ({ commit }) {
      commit('clearLoadedInnerCurtains')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inner_curtain/index.js